import DappPortalSDK, { WalletProvider } from '@linenext/dapp-portal-sdk'
import { ActiveChain } from '@/domains/chain'
import { ethers } from 'ethers'

export let walletProvider: WalletProvider
export let walletWeb3Provider: ethers.BrowserProvider
export const dappPortalConnectorId = 'dapp-portal'

export async function initializeWallet() {
  try {
    const sdk = await DappPortalSDK.init({ clientId: import.meta.env.VITE_DAPP_PORTAL_ID, chainId: String(ActiveChain.KAIA.id) })
    console.log('DappPortalSDK initialized')

    walletProvider = sdk.getWalletProvider()
    walletWeb3Provider = new ethers.BrowserProvider(walletProvider)
  } catch (error) {
    console.error('Failed to initialize DappPortalSDK:', error)
    throw error
  }
}
